import { CommonBody } from '@models/statistic'

/**
 * Create a common form body for course theme statistics API calls.
 * Used by both PDF and SCORM event handlers.
 */
export const createStatsCommonForm = (
  themeId: string,
  educationDestinationIri: string | undefined
): CommonBody => ({
  theme: `/api/course_chapter_themes/${themeId}`,
  educationDestination: educationDestinationIri,
})

/**
 * Convert educationId from URL params to API IRI format.
 * Returns undefined if educationId is empty or '0'.
 */
export const toEducationDestinationIri = (
  educationId: string
): string | undefined =>
  +educationId ? `/api/employee_education_destinations/${educationId}` : undefined
